// hideUI.js
var HideUi = pc.createScript('hideUi');

HideUi.attributes.add('uiElements', {type:'entity', array:true});

// initialize code called once per entity
HideUi.prototype.initialize = function() {
    this.tSwitch = false;
};

// update code called every frame
HideUi.prototype.update = function(dt) {
    if (this.app.keyboard.wasPressed(pc.KEY_SPACE)) {
        if(this.tSwitch){
            this.uiElements[0].enabled = true;
            this.uiElements[1].enabled = true;
            this.tSwitch = false;
        } else {
            this.uiElements[0].enabled = false;
            this.uiElements[1].enabled = false;
            this.tSwitch = true;
        }
        
        
    }

};

// swap method called for script hot-reloading
// inherit your script state here
// HideUi.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

